import { Card, CardContent } from '@material-ui/core';
import { CardTitleTypography } from 'framework/components/CardTitleTypography';
import { ErrorLabelledProperty } from 'framework/components/labelledProperty/ErrorLabelledProperty';
import { SuccessLabelledProperty } from 'framework/components/labelledProperty/SuccessLabelledProperty';
import { IPeppolIntegrationStatus } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { PeppolRoute } from '../integrations/IntegrationsRoutes';

type PeppolDashboardCardProps = {
	className?: string;
	style?: React.CSSProperties;
	data: IPeppolIntegrationStatus;
};

export const PeppolDashboardCard = ({ data, style, className }: PeppolDashboardCardProps) => {
	const strings = useLocalization();
	const { push } = useHistory();

	const onGoToPeppolIntegration = () => {
		push(PeppolRoute);
	};

	if (data === undefined) {
		return <></>;
	}

	return (
		<Card
			className={className}
			style={style}>
			<CardTitleTypography
				title={strings.peppolIntegration}
				withPadding
			/>
			<CardContent style={{ paddingTop: 0, paddingBottom: 16 }}>
				<div
					className='df-col'
					style={style}>
					{data.countNewPeppolRecords === 0 && (
						<SuccessLabelledProperty
							successMessage={strings.allForwarded}
							onClick={onGoToPeppolIntegration}
							spacing={3}
						/>
					)}
					{data.countNewPeppolRecords !== 0 && (
						<ErrorLabelledProperty
							error={strings.countInvoicesNotForwarded(data.countNewPeppolRecords)}
							onClick={onGoToPeppolIntegration}
							spacing={3}
						/>
					)}
				</div>
			</CardContent>
		</Card>
	);
};
